import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientConfig,
} from "@tanstack/react-query";

const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
  mutationCache: new MutationCache({
    onError: () => {},
  }),
  queryCache: new QueryCache({
    onError: () => {},
  }),
};

export const queryClient = new QueryClient(queryClientConfig);
